import { combineReducers } from 'redux';
import FilterApp from './filter';
import DataApp from './data';
import MapApp from './map'
import StatApp from './stat'
import TableApp from './table'
import LoginApp from './login'
import PublicApp from './public'

import app_styles from '../css/index.css';

function isBusy(state = false, action) {
  switch (action.type) {
    case 'GET_DATA':
    case 'SHOW_LOADING':
    case 'GET_QUERY_FILTERS':
    case 'GET_QUERIES':
    case 'SAVING_QUERY':
    case 'CALCULATE':
      return true;

    case 'RECEIVE_DATA':
    case 'SAVED_QUERY':
    case 'RECEIVE_QUERIES':
    case 'RECEIVE_QUERY':
    case 'RECEIVE_QUERY_FILTERS':
    case 'HIDE_LOADING':
    case 'CALCULATE_DONE':
    case 'ERROR':
      return false;

    default:
      return state;
  }
}

function busyText(state="Loading...", action){
  switch(action.type){
    case 'SET_BUSY_TEXT':
      return action.text
    default:
      return state;
  }
}

function showNav(state = true, action) {
  switch (action.type) {
    case 'SHOW_NAV':
      return true;

    case 'HIDE_NAV':
      return false;

    default:
      return state;
  }
}


const templateInitialState = {
  'height': window.innerHeight,
  'width' : window.innerWidth,
  'navHeight': app_styles.navHeight,
  'compHeight': window.innerHeight - app_styles.navHeight
}

function UserState(state={'user_id':0}, action) {
  switch (action.type) {
    default:
      return state;
  }
}

function Template(state=templateInitialState, action){
  switch (action.type) {
    case "SCREEN_RESIZE":
      var newState = Object.assign({},state)
      newState.height = window.innerHeight
      newState.width = window.innerWidth
      newState.compHeight = window.innerHeight - state.navHeight
      return newState

    default:
      return state
  }
}

const stateApp = combineReducers({
  showNav, isBusy, busyText, DataApp, MapApp, StatApp, Template, UserState, FilterApp, TableApp, LoginApp, PublicApp
});

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    console.log('RESETTING ALL REDUCERS')
    state = undefined
  }
  return stateApp(state, action)
}

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js